import PermissionsCard from "../core/PermissionsCard";
import { IPermissionModel } from "../../../../common/models/IPermissionModel";

export type PermissionsListItemProps = {
    permissions: IPermissionModel;
    expansionKey: string;
    expansion: { [key: string]: boolean; };
    toggleExpansion: (key: string) => void;
};
export default function PermissionsListItem({
    permissions, expansionKey, expansion, toggleExpansion
}: PermissionsListItemProps) {

    const customDetailsKey = `${expansionKey}:${permissions.targetObject.objectType}:${permissions.targetObject.id}`;
    const customDetailsExpanded = expansion[customDetailsKey];

    return (
        <PermissionsCard
            permissionModel={permissions}
            detailExpanded={customDetailsExpanded}
            onToggleDetailExpanded={() => toggleExpansion(customDetailsKey)}
        />
    );
}
